import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OfficeExpanceListComponent } from './office-expance-list/office-expance-list.component';
import { OfficeExpenseComponent } from './office-expense/office-expense.component';
import { OurownVehicleExpenseComponent } from './ourown-vehicle-expense/ourown-vehicle-expense.component';
import { OwnVehicleExpenceListComponent } from './own-vehicle-expence-list/own-vehicle-expence-list.component';
import { VehicleMaintainanceListComponent } from './vehicle-maintainance-list/vehicle-maintainance-list.component';
import { VehicleMaintenanceComponent } from './vehicle-maintenance/vehicle-maintenance.component';
import { EditOfficeExpenseComponent } from './edit-office-expense/edit-office-expense.component';
import { EditVehicleMaintenanceComponent } from './edit-vehicle-maintenance/edit-vehicle-maintenance.component';
import { ViewExpanceComponent } from './view-expance/view-expance.component';
import { ViewVehicleMaintanceComponent } from './view-vehicle-maintance/view-vehicle-maintance.component';
import { ViewOwnVehicleExpenseComponent } from './view-own-vehicle-expense/view-own-vehicle-expense.component';

const routes: Routes = [
  {path:'', redirectTo:"officeExpense", pathMatch:"full"},
  {path:'officeExpense', component:OfficeExpanceListComponent },
  {path:'AddOfficeExpense', component:OfficeExpenseComponent},
  {path:'editOfficeExpense/:id', component: EditOfficeExpenseComponent,},
  {path:'vehicleMaintenence', component:VehicleMaintainanceListComponent},
  // {
  //   path: 'expanceList', component:OfficeExpanceListComponent,
  // },
  {
    path: 'editVehicleMaintenance/:id', component: EditVehicleMaintenanceComponent,
  },
  {path: 'AddvehicleMaintenence', component:VehicleMaintenanceComponent},
  {path:'ownVehicleExpenceList', component:OwnVehicleExpenceListComponent},
  {path:'addOwnVehicleExpence', component:OurownVehicleExpenseComponent},
  {path:'editOwnVehicleExpence/:id', component:OurownVehicleExpenseComponent},

  {path:'view/:id', component:ViewExpanceComponent},
  {path:'viewMaintaince/:id', component:ViewVehicleMaintanceComponent},
  {path: 'ownVehicleExpenseView/:id', component: ViewOwnVehicleExpenseComponent}

  // {
  //   path: 'hireVicheleFlat', component:HireVehicleFlatComponent,
  // },
  // {
  //   path: 'hireVicheleMonthly', component:HireVehicleMonthlyComponent,
  // },
  // {
  //   path: 'AddOfficeExpense', component:OfficeExpenseComponent,
  // },
  // {
  //   path: 'ourownVehicleExpense', component:OurownVehicleExpenseComponent,
  // },
  

  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageExpenseLogRoutingModule { }
